import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectRefundsArchive = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dRefundsArchive,
);

export const selectRefundsArchiveFilters = createDraftSafeSelector(
  selectRefundsArchive,
  (state) => state.filters,
);

export const selectRefundsArchiveReceiptNumber = createDraftSafeSelector(
  selectRefundsArchiveFilters,
  (state) => state?.receiptNumber,
);

export const selectRefundsArchiveTableData = createDraftSafeSelector(
  selectRefundsArchive,
  (state) => state.data,
);

export const selectRefundsArchiveDetailItem = createDraftSafeSelector(
  selectRefundsArchive,
  (state) => state.detailItem,
);

export const selectRefundsArchivePagination = createDraftSafeSelector(
  selectRefundsArchive,
  (state) => state.pagination,
);
